type SuffixInputProps = {
  readonly id?: string;
  readonly value: string;
  readonly placeholder?: string;
  readonly suffix: string;
  readonly onChange: (value: string) => void;
  readonly disabled?: boolean;
  readonly invalid?: boolean;
  readonly inputMode?: 'decimal' | 'numeric';
  readonly 'aria-label'?: string | undefined;
  readonly 'aria-describedby'?: string | undefined;
};

export function SuffixInput(props: SuffixInputProps) {
  const { id, value, placeholder, suffix, onChange, disabled = false, invalid = false, inputMode } = props;
  const ariaDescribedBy = props['aria-describedby'];
  const ariaLabel = props['aria-label'];
  const wrapperClasses = [
    'flex h-control-md w-full items-stretch overflow-hidden rounded-md border bg-surface',
    'transition-colors duration-micro ease-out',
    'focus-within:border-interactive focus-within:shadow-focus',
    invalid ? 'border-danger-500 focus-within:border-danger-500 focus-within:shadow-focus-danger' : 'border-border',
    disabled ? 'opacity-60' : '',
  ]
    .filter((c) => c !== '')
    .join(' ');

  return (
    <div className={wrapperClasses}>
      <input
        id={id}
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-invalid={invalid || undefined}
        aria-label={ariaLabel}
        aria-describedby={ariaDescribedBy}
        inputMode={inputMode}
        className="min-w-0 flex-1 bg-transparent px-3 py-2 text-base font-sans text-text-primary focus:outline-none disabled:cursor-not-allowed"
      />
      {suffix !== '' && (
        <span
          aria-hidden
          className="inline-flex items-center border-l border-border bg-neutral-50 px-3 text-base-sm text-text-tertiary"
        >
          {suffix}
        </span>
      )}
    </div>
  );
}
